import { ApiService } from '../shared/services/core/api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocaleModel } from './models/locale.model'

@Injectable({
    providedIn: 'root'
  })
  export class LocaleService {
      constructor(private apiService: ApiService){}

      public getAllLocales(): Observable<LocaleModel[]>{
        return this.apiService.get<LocaleModel>('locale');
      }

      public getLocaleByLcid(lcid: number | null): Observable<LocaleModel>{
        return this.apiService.getAnySingle<LocaleModel>(`locale/getlocale/${!!lcid ? lcid : 2057}`);
      }
      
  }